<div hidden>
    <ng-template #dialogOverlay>
        <div
            style="
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1001;
                background-color: #000;
                opacity: 0.3;
                width: 100vw;
                height: 100vh;
            "
        ></div>
    </ng-template>
</div>
<div *ngIf="dialogVisible; then dialogOverlay"></div>
<div class="card">

    <!-- <p-header>
        <div class="process-header">
            <h2 style="margin: 0;">
                <div style="padding-left: 0.5rem; padding-right: 0.5rem">
                    <a href="javascript:;" (click)="op.show($event)">
                        {{ process.ProcessTitle }}
                    </a>
                </div>
            </h2>
        </div>
    </p-header> -->
    <p-accordion [multiple]="true">
        <p-accordionTab [selected]="true" header="Filters">
            <p-toolbar>
                <form
                    [formGroup]="filterFormGroup"
                    #filterForm="ngForm"
                    id="filterForm"
                >
                    <div class="flex items-center gap-1">
                        <p-floatLabel variant="on">
                            <p-datepicker
                                id="startDate"
                                formControlName="startDate"
                                appendTo="body"
                                [yearNavigator]="true"
                                [monthNavigator]="true"
                                yearRange="2010:2030"
                            ></p-datepicker>
                            <label for="startDate">Start Date</label>
                        </p-floatLabel>
                        <p-floatLabel variant="on">
                            <p-datepicker
                                formControlName="endDate"
                                appendTo="body"
                                [yearNavigator]="true"
                                [monthNavigator]="true"
                                yearRange="2010:2030"
                            ></p-datepicker>
                            <label for="endDate">End Date</label>
                        </p-floatLabel>
                    </div>
                </form>
                <form
                    [formGroup]="directReportsGroup"
                >
                    <p-dialog
                        appendTo="body"
                        [contentStyle]="{
                            'min-width': '20rem'
                        }"
                        header="Disapproval"
                        [(visible)]="dialogVisible"
                        #disapprovalDialog
                    >
                        <textarea
                            pInputTextarea
                            formControlName="disapprovalComment"
                            style="width: 100%"
                            placeholder="(Optional) - Enter a comment for dispapproval."
                        ></textarea>
                        <ng-template #footer >
                            <button
                                pButton
                                type="button"
                                label="OK"
                                class="p-button-success"
                                (click)="dialogVisible = false"
                            ></button>
                        </ng-template>
                    </p-dialog>
                    <p-floatLabel variant="on">
                        <div
                            [ngClass]="{ 'hidden': !(validating || approving || superUserEnabled) }"
                        >
                            <ef-user-selector-dropdown
                                [Users]="directReports"
                                formControlName="ddlDirectReports"
                            >
                            </ef-user-selector-dropdown>
                        </div>
                        <label [ngClass]="{ 'hidden': !(validating || approving || superUserEnabled) }">
                            {{ process.ProcessTitle }}
                            for
                            <label
                                *ngIf="
                                    !(validating || approving || superUserEnabled)
                                "
                            >
                                {{
                                    selectedUser?.EmployeeName ||
                                        userInfo?.EmployeeName
                                }}
                            </label>
                        </label>
                    </p-floatLabel>
                </form>
            </p-toolbar>
        </p-accordionTab>
        <p-accordionTab #summary [selected]="true">
            <ng-template #header>
                <div class="flex items-center">
                    <div>
                        Summary: Report Nbr:
                        {{ selectedExpense?.ExpReportNbr }}
                    </div>
                    <div class="mx-4">
                        Report Date:
                        {{ selectedExpense?.ReportDate | date: 'shortDate' }}
                    </div>
                    <div>
                        Report Total:
                        {{
                            selectedExpense?.ReportTotal
                                | currency
                        }}
                    </div>
                </div>
            </ng-template>
            <p-toolbar>
                <div class="flex flex-wrap items-center gap-2">
                    <button
                        pButton
                        type="button"
                        [label]="ExpenseLabel"
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        [ngClass]="{ 'hide-element': validating || approving }"
                        [disabled]="
                            directReportsGroup.controls['superUser'].value &&
                            !directReportsGroup.controls['ddlDirectReports'].value
                        "
                        (click)="
                            $event.stopPropagation();
                            addExpenseReportMenu.toggle($event)
                        "
                    ></button>
                    <p-menu
                        #addExpenseReportMenu
                        [popup]="true"
                        [model]="addExpenseReportMenuItems"
                        appendTo="body"
                    ></p-menu>
                    <button
                        #approveExpense
                        pButton
                        type="button"
                        aria-label="Approve"
                        [ngClass]="{ 'hide-element': !approving }"
                        [disabled]="
                            !directReportsGroup.controls['ddlDirectReports']
                                .value || selectedExpenses?.length === 0
                        "
                        label="Approve"
                    ></button>
                    <button
                        #unapproveExpense
                        pButton
                        type="button"
                        aria-label="Unapprove"
                        [ngClass]="{ 'hide-element': !approving }"
                        [disabled]="
                            !directReportsGroup.controls['ddlDirectReports']
                                .value || selectedExpenses?.length === 0
                        "
                        label="Unapprove"
                    ></button>
                    <button
                        #validateExpense
                        pButton
                        type="button"
                        aria-label="Validate"
                        [ngClass]="{ 'hide-element': !validating }"
                        [disabled]="
                            !directReportsGroup.controls['ddlDirectReports']
                                .value || selectedExpenses?.length === 0
                        "
                        label="Validate"
                    ></button>
                    <button
                        #unvalidateExpense
                        pButton
                        type="button"
                        aria-label="Unvalidate"
                        [ngClass]="{ 'hide-element': !validating }"
                        [disabled]="
                            !directReportsGroup.controls['ddlDirectReports']
                                .value || selectedExpenses?.length === 0
                        "
                        label="Unvalidate"
                    ></button>
                    <button
                        #disapproveExpense
                        pButton
                        type="button"
                        aria-label="Disapprove"
                        [ngClass]="{ 'hide-element': !(validating || approving) }"
                        [disabled]="
                            !directReportsGroup.controls['ddlDirectReports']
                                .value || selectedExpenses?.length === 0
                        "
                        label="Disapprove"
                    ></button>
                    <p-message
                        severity="warn"
                        [text]="failureMessage"
                        [closable]="true"
                        [style]="{ 'margin-left': '0.75rem', 'white-space': 'normal' }"
                        *ngIf="failureMessage"
                    ></p-message>
                    <p-message
                        severity="info"
                        [text]="successMessage"
                        [closable]="true"
                        [style]="{ 'margin-left': '0.75rem', 'white-space': 'normal' }"
                        *ngIf="successMessage && !failureMessage"
                    ></p-message>
                </div>
                <div class="header-color-text float-right">
                    <span>Click to open detail.&nbsp;</span
                    ><span
                        [hidden]="approving || validating"
                        >Double-click to edit.</span
                    >
                </div>
            </p-toolbar>
            <ef-expense-summary-list
                [expenses]="expenses || []"
                [directReports]="directReports"
                [roleId]="roleId"
                [selectedUser]="selectedUser"
                [selectedExpense]="selectedExpense"
                [superUserEnabled]="superUserEnabled"
                [userColors]="userWebColors"
                [tasks]="tasks"
                [expenseItems]="expenseItems"
                [startDate]="startDate"
                [endDate]="endDate"
                [process]="process"
                [validating]="validating"
                [approving]="approving"
                [canOversign]="!(superUserEnabled && selectedUser)"
                [showReimbursedAmount]="showReimbursedAmount"
                [approveClick]="approveClick$ | async"
                [validateClick]="validateClick$ | async"
                [unapproveClick]="unapproveClick$ | async"
                [unvalidateClick]="unvalidateClick$ | async"
                [disapproveClick]="disapproveClick$ | async"
                (clickExpense)="onClickExpense($event)"
                (SelectExpenses)="onSelectExpenses($event)"
                (editExpense)="onEditExpense($event)"
                (deleteExpense)="onDeleteExpense($event)"
                (oversignExpense)="onOversignExpense($event)"
                (ConvertExpense)="onConvertExpense($event)"
                (ValidateExpense)="onValidateExpense($event)"
                (ApproveExpense)="onApproveExpense($event)"
                (UnvalidateExpense)="onUnvalidateExpense($event)"
                (UnapproveExpense)="onUnapproveExpense($event)"
                (DisapproveExpense)="onDisapproveExpense($event)"
                (CanClose)="onCanClose($event)"
                (AddSelectedExpense)="onAddSelectedExpense($event)"
                (RemoveSelectedExpense)="onRemoveSelectedExpense($event)"
                (ClearSelectedExpenses)="onClearSelectedExpenses($event)"
            >
            </ef-expense-summary-list>
        </p-accordionTab>
        <p-accordionTab
            [selected]="true"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [header]="detailAccordionHeader"
        >
            <p-toolbar
                *ngIf="selectedExpense && !(validating || approving)"
                styleClass="mb-2"
            >
                <div class="flex flex-wrap items-center gap-2">
                    <button
                        pButton
                        type="button"
                        label="Per Diem Line"
                        icon="pi pi-plus"
                        [disabled]="!canEdit"
                        (click)="
                            onAddExpenseTypeToSelected(
                                $event,
                                TravelTypeEnum.PerDiem
                            )
                        "
                    ></button>
                    <button
                        pButton
                        type="button"
                        label="Mileage Line"
                        icon="pi pi-plus"
                        [disabled]="!canEdit"
                        (click)="
                            onAddExpenseTypeToSelected(
                                $event,
                                TravelTypeEnum.Mileage
                            )
                        "
                    ></button>
                    <button
                        pButton
                        type="button"
                        label="Receipt Line"
                        icon="pi pi-plus"
                        [disabled]="!canEdit"
                        (click)="
                            onAddExpenseTypeToSelected(
                                $event,
                                TravelTypeEnum.Receipt
                            )
                        "
                    ></button>
                </div>
            </p-toolbar>
            <p-toggleButton
                (click)="$event.stopPropagation()"
                [hidden]="panelOpenState === false"
                [(ngModel)]="showLineDetails"
                [onLabel]="'Hide Travel Detail'"
                [offLabel]="'Show Travel Detail'"
            ></p-toggleButton>

            <ef-expense-detail-list
                [validating]="validating"
                [approving]="approving"
                [canEdit]="canEdit"
                [canOpen]="canOpen"
                [expenseLines]="expenseLines"
                [perDiemTypes]="perDiemTypes"
                [travelTypes]="travelTypes"
                [showDetails]="showLineDetails"
                [selectedExpense]="selectedExpense"
                (showPdbo)="onShowPdbo($event)"
                (selectDetail)="onSelectDetail($event)"
                (editDetail)="onEditDetail($event)"
                (deleteDetail)="onDeleteDetail($event)"
                class="pull-left"
            >
            </ef-expense-detail-list>
        </p-accordionTab>
        <p-accordionTab [selected]="true" [header]="receiptAccordionHeader">
            <ef-expense-receipt-list
                [validating]="validating"
                [approving]="approving"
                [canEdit]="canEdit"
                [canOpen]="canOpen"
                [expenseReceipts]="expenseReceipts"
                [selectedDetail]="selectedDetail"
                [selectedExpense]="selectedExpense"
                (editReceipt)="onEditReceipt($event)"
                (selectReceipt)="onSelectReceipt($event)"
                (deleteReceipt)="onDeleteReceipt($event)"
            >
            </ef-expense-receipt-list>
        </p-accordionTab>
    </p-accordion>

    <div class="legend" style="margin-top: 5px; width: 100%">
        <div class="flex items-center">
            <div>
                <label style="font-size: 12px;" class="mr-2">Status Colors: </label>
            </div>
            <button
                pButton
                *ngFor="let item of userWebColors"
                [style.color]="item.Forecolor_Hex"
                [style.backgroundColor]="item.Backcolor_hex"
                style="height: 1.5em; font-size: 12px; border: none; border-radius: 0px;"
                title="{{ item.Status }}:{{ item.StatusID }}"
            >
                {{ item.Status }}
                <!-- {{ item.StatusID }}-->
            </button>
        </div>
    </div>
</div>
